import { BankAccount, NewManualBankAccount, PaymentMethodOptions, PaymentMethodQualifications } from 'types/payment';
import { investmentEntityRequest } from '@utils/request';
import { PlaidLinkAccountRequest } from 'types/plaid';
import { TransactionType } from 'types/add-funds';

export function formatBankAccounts(unformattedAccounts: Array<BankAccount>): Array<BankAccount> {
	return unformattedAccounts.map((bankAccount: BankAccount) => {
		const properCaseAccountType =
			bankAccount.accountType.charAt(0).toUpperCase() + bankAccount.accountType.slice(1).toLowerCase();
		bankAccount.label = bankAccount.label + ' (' + properCaseAccountType + ')';
		return bankAccount;
	});
}

export async function getBankAccounts(): Promise<Array<BankAccount>> {
	const response = await investmentEntityRequest.get(`/bank-accounts`);

	return formatBankAccounts(response.data);
}

export async function getPaymentMethod(qualifications: PaymentMethodQualifications): Promise<PaymentMethodOptions> {
	const response = await investmentEntityRequest.post(`/payment-options`, qualifications);

	return {
		bankAccounts: formatBankAccounts(response.data.bankAccounts),
		stripePaymentOptions: response.data.stripePaymentOptions,
		isStripeAllowed: response.data.isStripeAllowed
	};
}

export async function linkManualBankAccount(payload: NewManualBankAccount): Promise<BankAccount> {
	const response = await investmentEntityRequest.post(`/link-manual-bank-account`, payload);
	return response.data as BankAccount;
}

export async function linkPlaidBankAccount(payload: PlaidLinkAccountRequest): Promise<BankAccount> {
	const response = await investmentEntityRequest.post(`/account/link-plaid-account`, payload);
	return response.data as BankAccount;
}

export async function updateNoteInvestmentBankAccount(noteInvestmentId: string, bankAccountId: string): Promise<void> {
	await investmentEntityRequest.post(`/note-investment/${noteInvestmentId}/attach-bank-account`, {
		bankAccountId: bankAccountId,
		transactionType: 'ACH'
	});
}

export async function updateInvestmentBankAccount(
	orderGroupId: string,
	bankAccountId: string,
	ignoreError = false
): Promise<void> {
	await investmentEntityRequest.post(
		`/order-group/${orderGroupId}/attach-bank-account`,
		{
			bankAccountId: bankAccountId,
			transactionType: 'ACH'
		},
		{ suppressToast: () => ignoreError }
	);
}

export async function attachPaymentMethod(
	orderGroupId: string,
	paymentMethodId: string,
	transactionType: TransactionType = 'ACH',
	ignoreError = false
): Promise<void> {
	await investmentEntityRequest.post(
		`/order-group/${orderGroupId}/attach-payment-method`,
		{
			paymentMethodId,
			transactionType
		},
		{ suppressToast: () => ignoreError }
	);
}

export async function updatePrimaryBankAccount(bankAccountId: string): Promise<BankAccount> {
	const response = await investmentEntityRequest.post(`/bank-account/primary`, { id: bankAccountId });
	return response.data as BankAccount;
}

export async function deleteBankAccount(bankAccountId: string): Promise<void> {
	await investmentEntityRequest.delete(`/bank-account`, { data: { id: bankAccountId } });
}
